import React, { useEffect, useRef } from "react";
import SEO from "../components/SEO";

const Search = () => {
  const containerRef = useRef(null);

  useEffect(() => {
    // 1. Load the Script (Standard)
    const scriptId = "hospitable-search-widget-script";
    if (!document.getElementById(scriptId)) {
      const script = document.createElement("script");
      script.id = scriptId;
      script.src =
        "https://hospitable.b-cdn.net/direct-property-search-widget/hospitable-search-widget.prod.js";
      script.async = true;
      document.body.appendChild(script);
    }

    // 2. THE FIX: Watch for the widget "breaking out"
    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        mutation.addedNodes.forEach((node) => {
          // Check if the new node is an element (div, etc)
          if (node.nodeType === 1) {
            // Check if this is the "Unavailable" section by looking for its specific text or class
            // (Hospitable usually appends a div that contains this text)
            if (
              node.innerText &&
              node.innerText.includes("unavailable properties")
            ) {
              // FORCE MOVE: Grab the node and append it to OUR container instead of the body
              if (containerRef.current) {
                containerRef.current.appendChild(node);
              }
            }
          }
        });
      });
    });

    // Start watching the document body for added nodes
    observer.observe(document.body, { childList: true, subtree: false });

    // Cleanup when page is left
    return () => observer.disconnect();
  }, []);

  return (
    // Added 'min-h-screen' here to ensure the page takes up full height
    <div className="pt-40 pb-20 max-w-7xl mx-auto px-4 min-h-[80vh] overflow-x-hidden">
      <SEO
        title="Search Availability | ACF Luxury Stays"
        description="Find available luxury vacation rentals for your selected dates in Telluride, Beaver Creek, San Diego, and Miami Beach."
        url="/search"
      />

      <div className="text-center mb-8 md:mb-12">
        <h1 className="text-2xl md:text-3xl font-primary text-acf-blue mb-4">
          Search Results
        </h1>
        <div className="w-16 h-1 bg-acf-gold mx-auto mb-6 md:mb-8"></div>
        <p className="text-gray-600 font-secondary text-sm md:text-base">
          Showing available properties for your selected dates.
        </p>
      </div>

      {/* The Results Widget Container */}
      {/* We attach the 'ref' here so we can force content back into this box */}
      <div
        ref={containerRef}
        className="hospitable-results-container min-h-[400px] relative flex flex-col gap-8"
      >
        <hospitable-direct-mps
          identifier="6a29122d-cd8d-4277-90cf-c4717aef8427"
          type="custom"
        ></hospitable-direct-mps>
      </div>
    </div>
  );
};

export default Search;
